<template>
  <v-container>
    <div>
      <v-row justify="space-between">
        <v-col cols="12" sm="6" justify="center">
          <p class="header-title"> {{ $t('order_unit.title') }} </p>
        </v-col>

        <v-col cols="12" sm="6" justify="center">
          <div class="d-flex flex-row-reverse">
            <v-dialog v-model="dialog" persistent max-width="70%">
              <template v-slot:activator="{ on }" v-if="checkShowFunction()">
                <v-btn color="primary" dark class="mb-2" v-on="on">{{ $t('common.create') }}</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row no-gutters>
                      <v-col cols="12" sm="6" class="pr-2">
                        <v-text-field v-model="editedItem.name" :rules="stringRules"
                                      v-bind:label="$t('order_unit.name')" outlined dense></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="6" class="pl-2">
                        <v-autocomplete v-model="selectCustomerType" :items="customerTypes" item-text="name"
                                        v-bind:label="$t('order_unit.customer_type')" outlined return-object
                                        dense></v-autocomplete>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col cols="12" sm="6" class="pr-2">
                        <v-autocomplete v-model="selectProvince" :items="provinces" item-text="province_name"
                                        v-bind:label="$t('order_unit.province')" outlined return-object
                                        dense></v-autocomplete>
                      </v-col>

                      <v-col cols="12" sm="6" class="pl-2">
                        <v-autocomplete v-model="selectDistrict" :items="districts"
                                        item-text="district_name" v-bind:label="$t('order_unit.district')"
                                        outlined return-object dense></v-autocomplete>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-col>
                        <v-text-field v-model="editedItem.description" v-bind:label="$t('order_unit.description')"
                                      outlined dense></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <gmap-autocomplete
                          @place_changed="setPlace" :value="addressInput" class="my-span">
                      </gmap-autocomplete>

                      <GmapMap
                          :center="center"
                          :zoom="14"
                          map-type-id="terrain"
                          style="width: 100%; height: 500px"
                          :options="{
                               mapTypeControl: false,
                               streetViewControl: false,
                               fullscreenControl: true,
                             }"
                      >

                        <GmapMarker ref="myMarker"
                                    :position="center"
                                    :draggable="true" @dragend="updateCoordinates"/>
                      </GmapMap>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" dark @click="close">{{ $t('common.cancel') }}</v-btn>
                  <v-btn color="primary" dark @click="save">{{ $t('common.save') }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <download-excel
                class="btn btn-default"
                :data="originalDesserts"
                :fields="json_fields"
                worksheet="My Worksheet"
                name="DVDH.xls"
            >
              <v-btn color="primary" dark class="mr-5">{{ 'Download' }}</v-btn>
            </download-excel>

            <v-btn color="primary" dark @click="getData" class="mr-5">{{ $t('common.refresh') }}</v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
    <v-data-table :headers="headers" :items="desserts" :search="search" sort-by="email" :loading="loading"
                  class="elevation-1" hide-default-footer :page.sync="page" :items-per-page="itemsPerPage"
                  @page-count="pageCount = $event" @pagination="calculateItems">
      <template v-slot:top>
        <v-toolbar flat color="white" class="pt-5">
          <v-row justify="start">
            <v-col cols="12" sm="2">
              <span>Tổng số: <span class="summaryFont"> {{ totalItems }} </span> </span>
            </v-col>

            <v-col cols="12" sm="1">
              <v-autocomplete v-model="itemsPerPage" :items="numberPage" outlined :dense="true"></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="2">
              <v-autocomplete v-model="selectProvinceFilter" :items="provinceFilters" item-text="province_name"
                              v-bind:label="$t('location_assign.select_province')" return-object outlined
                              dense></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="2">
              <v-autocomplete v-model="selectDistrictFilter" :items="districtFilters" item-text="district_name"
                              v-bind:label="$t('location_assign.select_district')" return-object outlined
                              :dense="true"></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="2">
              <v-autocomplete v-model="selectOption" :items="options" item-text="title"
                              v-bind:label="$t('order_unit.option')" return-object outlined
                              :dense="true"></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="3">
              <v-text-field v-model="search" append-icon="search" v-bind:label="$t('common.search')" single-line
                            hide-details outlined :dense="true"></v-text-field>
            </v-col>
          </v-row>
        </v-toolbar>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)" v-show="selectOption.value > 0">
          edit
        </v-icon>
        <v-icon small @click="deleteItem(item)" v-show="selectOption.value > 0">
          delete
        </v-icon>

      </template>

      <template v-slot:[`item.customerType`]="{ item }">
                <span class="contentName">
                    {{ item.customerType ? item.customerType.name : '' }}
                </span>
      </template>

      <template v-slot:[`item.vtProvince`]="{ item }">
                <span class="contentName">
                    {{ item.vtProvince ? item.vtProvince.province_name : '' }}
                </span>
      </template>

      <template v-slot:[`item.vtDistrict`]="{ item }">
                <span class="contentName">
                    {{ item.vtDistrict ? item.vtDistrict.district_name : '' }}
                </span>
      </template>

      <template v-slot:[`item.sale`]="{ item }">
        <div class="contentAddress" v-if="item.sale">
          <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
            <template v-slot:activator="{ on }">
              <v-avatar v-on="on" size="30" class="mr-1">
                <img v-if="item.sale.avatar" :src="baseImage + item.sale.avatar"/>
                <img v-else src='@/assets/avatar_default.png'/>
              </v-avatar>
            </template>
            <span>
                  {{ item.sale.fullname }}
                </span>
          </v-tooltip>
          <span>
                {{ item.sale.nickname }}
              </span>
        </div>
        <div class="contentAddress" v-else>
          <span>
                {{ $t('order_unit.unassign') }}
          </span>
        </div>

      </template>

      <template v-slot:[`item.create`]="{ item }">
        <v-btn color="primary" dark @click="showTargetDialog(item)">
          {{ $t('order_unit.create_target') }}
        </v-btn>
      </template>

      <template v-slot:no-data>
        <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
      </template>
    </v-data-table>

    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>

    <target-dialog v-model="dialogTarget" :editedItem="editedTarget" :type="0" @closeDialog="closeTargetDialog"
                   v-if="editedTarget">
    </target-dialog>

  </v-container>
</template>

<script>
import i18n from '@/plugins/i18n';
import {gmapApi} from 'vue2-google-maps';
import TargetDialog from "@/components/TargetDialog";

export default {

  data: () => ({
    baseImage: process.env.VUE_APP_BASE_IMAGE,
    baseAttach: process.env.VUE_APP_BASE_ATTACH,

    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    totalItems: 0,

    dialogTarget: false,

    numberPage: [
      5, 10, 15, 20, 25
    ],

    editedTarget: {},

    customerTypes: [],
    selectCustomerType: {},

    selectProvince: null,
    selectProvinceFilter: null,
    provinces: [],
    provinceFilters: [],

    selectDistrict: null,
    districts: [],
    selectDistrictFilter: {district_name : "Tất cả", _id : "-1"},
    districtFilters: [],

    options: [
      {title: i18n.t('common.all'), value: -1},
      {title: i18n.t('common.owner_option'), value: 1}
    ],

    selectOption: {title: i18n.t('common.owner_option'), value: 1},

    filterProvinces: [],
    addressInput: '',

    search: '',
    dialog: false,
    loading: true,
    headers: [
      {text: '#', align: 'left', sortable: false, value: 'index'},
      {text: i18n.t('order_unit.name'), value: 'name'},
      {text: i18n.t('order_unit.customer_type'), value: 'customerType'},
      {text: '', sortable: false, value: 'customerType.name', align: ' d-none'},
      {text: i18n.t('order_unit.province_display'), value: 'vtProvince'},
      {text: '', sortable: false, value: 'vtProvince.province_name', align: ' d-none'},
      {text: i18n.t('order_unit.district_display'), value: 'vtDistrict'},
      {text: '', sortable: false, value: 'vtDistrict.district_name', align: ' d-none'},

      {text: i18n.t('order_unit.sale_assign'), value: 'sale'},
      {text: '', sortable: false, value: 'sale.fullname', align: ' d-none'},

      // {text: i18n.t('order_unit.description'), value: 'description'},
      {text: '', value: 'create', sortable: false},
      {text: '', value: 'action', sortable: false}
    ],

    desserts: [],
    originalDesserts: [],
    editedIndex: -1,
    editedItem: {},
    defaultItem: {},
    stringRules: [
      v => !!v || i18n.t('validate.not_empty'),
      // v => (v && v.length > 5) || i18n.t('validate.string_invalid')
    ],

    coordinate: {lat: 21.001373669878184, lng: 105.83511388671808},
    center: {lat: 21.001373669878184, lng: 105.83511388671808},

    json_fields: {
      "STT": "index",
      "Tên": "name",
      "Phân loại khách hàng": "customerType.name",
      "Tỉnh/TP": "vtProvince.province_name",
      "Quận/Huyện": "vtDistrict.district_name",
      "Nhân viên": "sale.fullname"
    },

  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? i18n.t('order_unit.add') : i18n.t('order_unit.edit')
    },

    google: gmapApi
  },

  components: {
    TargetDialog: TargetDialog
  },

  watch: {
    dialog(val) {
      val || this.close()
    },

    selectProvince(val) {
      if (val) {
        this.getDistrictByProvinceID(val.province_id);
      }
    },

    selectProvinceFilter(val) {
      if (val) {
        this.getDistrictFilterByProvinceID(val.province_id);
      }
    },

    selectDistrictFilter(val) {
      if (val) {
        this.filterData();
      }
    },

    selectOption(val) {
      if (val) {
        this.getData();
      }
    }
  },

  async created() {
    await this.getProvince();
    await this.getCustomerType();
    await this.getData();
    // await this.getData();
    //
    // await Promise.all([
    //   this.getProvince(),
    //   this.getCustomerType(),
    // ]);
  },

  methods: {
    initialize() {
    },

    checkShowFunction() {
      const value = (this.$getUserType == 1 && this.$getUserCategory >= 2) || this.$isAdmin;
      return value;
    },

    filterData() {
      if (!this.originalDesserts || this.originalDesserts.length == 0) {
        return;
      }

      const self = this;

      if (this.selectProvinceFilter) {
        this.desserts = [].concat(this.originalDesserts.filter(item => this.selectProvinceFilter._id === item.vtProvince._id));
      }

      if (self.selectDistrictFilter._id != "-1") {
        // this.desserts = [].concat(this.desserts.filter(item => this.selectDistrictFilter._id === item.vtDistrict._id));
        self.desserts = [].concat(self.desserts.filter(function(item) {
          if (item.vtDistrict) {
            return item.vtDistrict._id === self.selectDistrictFilter._id;
          }
        }));
      }

      // if (self.selectOption.value > 0) {
      //   self.desserts = [].concat(self.desserts.filter(function(item) {
      //     if (item.sale) {
      //       return item.sale._id == self.$getUserID;
      //     }
      //   }));
      // }

      this.desserts.forEach((item, index) => item.index = index + 1);
      this.totalItems = this.desserts.length;
    },

    showTargetDialog() {
      this.dialogTarget = true;
      this.editedTarget = {
      };
    },

    closeTargetDialog(value) {
      this.dialogTarget = value;
      // this.editedItem = null;
      // this.editedTarget = null;
    },

    setPlace(place) {
      this.center.lat = place.geometry.location.lat();
      this.center.lng = place.geometry.location.lng();
      this.coordinate = {
        lat: this.center.lat,
        lng: this.center.lng
      };
    },


    calculateItems(pagination) {
      this.totalItems = pagination.itemsLength;
    },

    updateCoordinates(location) {
      this.coordinate = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng(),
      };
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.selectProvince = this.editedItem.vtProvince;
      this.selectDistrict = this.editedItem.vtDistrict;

      if (this.editedItem.lat !== 0 && this.editedItem.lng !== 0) {
        this.center.lat = this.editedItem.lat;
        this.center.lng = this.editedItem.lng;

        this.coordinate = {
          lat: this.center.lat,
          lng: this.center.lng
        };
      }
      this.dialog = true
    },

    async deleteItem(item) {
      const agree = confirm(i18n.t('common.confirm_delete'))
      if (agree) {
        const response = await this.$http.delete(process.env.VUE_APP_ORDER_UNIT_API + item._id);
        if (response.data && response.data.success) {
          this.desserts.splice(item.index - 1, 1);
          this.desserts.forEach((item, index) => item.index = index + 1);
        } else if (response.data && !response.data.success) {
          alert(i18n.t(response.data.message));
        } else {
          alert(i18n.t('validate.request_error'));
        }
      }
    },

    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.selectProvince = null;
        this.selectDistrict = null;
        this.addressInput = '';
      }, 300)
    },

    async save() {
      const self = this;

      if (!this.editedItem.name || this.editedItem.name.length == 0) {
        alert(i18n.t('validate.infor_empty'));
        return;
      }

      let requestBody = {
        name: self.editedItem.name,
        customerType: self.selectCustomerType,
        vtProvince: self.selectProvince,
        vtDistrict: self.selectDistrict,
        lat: self.coordinate.lat,
        lng: self.coordinate.lng,
        description: self.editedItem.description,
      }

      if (this.editedIndex > -1) {
        try {
          const response = await this.$http.put(process.env.VUE_APP_ORDER_UNIT_API + self.editedItem._id, requestBody);

          if (response.data && response.data.success) {
            self.editedItem = {
              ...requestBody,
              _id: self.editedItem._id,
            }
            Object.assign(this.desserts[this.editedIndex], this.editedItem);
            self.editedItem = {};
          } else if (response.data && !response.data.success) {
            alert(i18n.t(response.data.message));
          } else {
            alert(i18n.t('validate.request_error'));
          }
        } catch (e) {
          console.log(e.stack);
          alert(i18n.t('validate.request_error'));
        }
      } else {
        try {
          const response = await this.$http.post(process.env.VUE_APP_ORDER_UNIT_API, requestBody);

          if (response.data && response.data.success) {
            self.editedItem = {
              ...requestBody,
              _id: response.data.data.id,
            }

            self.desserts.splice(0, 0, self.editedItem);
            self.desserts.forEach((item, index) => item.index = index + 1);
            self.editedItem = {};

            self.$fire({
              title: i18n.t('common.success'),
              text: "",
              type: "success"
            }).then(() => {

            });
          } else if (response.data && !response.data.success) {
            alert(i18n.t(response.data.message));
          } else {
            alert(i18n.t('validate.request_error'));
          }
        } catch (e) {
          console.log(e.stack);
          alert(i18n.t('validate.request_error'));
        }
      }
      this.close()
    },

    async getData() {
      this.loading = true;
      const self = this;

      try {
        let requestURL;
        // requestURL = process.env.VUE_APP_ORDER_UNIT_API;

        if (self.selectOption.value < 0 || this.$isAdmin) {
          requestURL = process.env.VUE_APP_ORDER_UNIT_API;
        } else {
          if (this.$getUserCategory === 1) {
            requestURL = process.env.VUE_APP_ORDER_UNIT_API + '?sale=' + self.$getUserID;
          } else {
            requestURL = process.env.VUE_APP_ORDER_UNIT_API + 'context/' + self.$getUserContextID;
          }
        }

        const response = await this.$http.get(requestURL);
        this.loading = false;

        if (response.data && response.data.success) {
          const contextArr = response.data.data;
          contextArr.forEach((item, index) => item.index = index + 1);

          self.desserts = contextArr;
          self.originalDesserts = contextArr;
          self.totalItems = this.desserts.length;

          self.filterData();
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    async getProvince() {
      this.provinces = await this.$getAllProvinces();
      this.selectProvince = this.provinces[0];

      this.provinceFilters = [].concat(this.provinces);
      this.selectProvinceFilter = this.provinceFilters[0];
    },

    // async getProvince() {
    //   try {
    //     const response = await this.$http.get(process.env.VUE_APP_VT_PROVINCE_API);
    //     if (response.data && response.data.success) {
    //       this.provinces = response.data.data;
    //       this.selectProvince = this.provinces[0];
    //
    //       this.provinceFilters = response.data.data;
    //       this.selectProvinceFilter = this.provinceFilters[0];
    //     }
    //   } catch (e) {
    //     console.log(e.stack);
    //   }
    // },

    async getCustomerType() {
      try {
        const response = await this.$http.get(process.env.VUE_APP_CUSTOMER_TYPE_API);
        if (response.data && response.data.success) {
          this.customerTypes = response.data.data;
          if (this.customerTypes.length > 0) {
            this.selectCustomerType = this.customerTypes[0];
          }
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    async getDistrictByProvinceID(provinceId) {
      const contextArr = await this.$getDistrictByProvince(provinceId);
      this.districts = [].concat(contextArr);

      if (this.districts.length > 0 && !this.selectDistrict) {
        this.selectDistrict = this.districts[0];
      }
    },

    async getDistrictFilterByProvinceID(provinceId) {
      const contextArr = await this.$getDistrictByProvince(provinceId);

      const optionAll = {
        district_name : "Tất cả",
        _id : "-1"
      }

      this.selectDistrictFilter = optionAll;
      this.districtFilters = [optionAll].concat(contextArr);
    },
  },
}
</script>

<style>
.my-span {
  background-color: white;
  margin-top: 5px;
  margin-left: 5px;
  border: 1px solid lightgray;
  border-radius: 5px;
  height: 40px;
  width: 30%;
  position: absolute;
  z-index: 100;
  outline: none !important;
  padding-left: 10px;
  padding-right: 10px;
}

</style>